import {Component, Element, Event, type EventEmitter, h, Host, Prop, State} from '@stencil/core';
import {type SupportButtonLabel, SupportButtonLabels} from './support-button.labels';
import {widgetStatistics} from './support-button-statistics';
import type {AnalyticsGenericEvent} from '../../../utils/analytics/AnalyticsGenericEvent';

@Component({
  tag: 'uiaas-search-support-button',
  styleUrl: 'support-button.scss',
  shadow: true
})
export class SupportButton {

  /**
   * Used for defining href URL and fetching localized labels.
   * Substitutes {xx} in 'https://se.com/{xx}/{yy}/work/support/'
   */
  @Prop()
  readonly country: string;

  /**
   * Used for defining href URL and fetching localized labels.
   * Substitutes {yy} in 'https://se.com/{xx}/{yy}/work/support/'
   */
  @Prop()
  readonly language: string;

  /**
   * Explicitly overrides href URL defining logic with specified URL.
   */
  @Prop({mutable: true})
    url: string;

  @Prop()
  readonly appName: string;

  @Prop()
  readonly anchorTarget: string = '';

  @Prop()
  readonly isFullHeight: boolean = false;

  @Prop()
  readonly isDashboardView: boolean = false;

  @Prop()
  readonly isDashboardMobile: boolean = false;

	@Prop()
	  readonly dashboardTabName: string;

  @Prop() readonly analyticsTabName?: string;

  @Element()
    el: HTMLElement;

  @State()
    tabName: string;

  @Event({
    eventName: 'search:widgetEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    statisticsEventEmitter: EventEmitter<AnalyticsGenericEvent>;

    @State() term: string = '';
  

    private getLink(): string {
        const supportLink = this.appName == 'apc' ?
          this.url = `https://www.apc.com/${this.country}/${this.language}/support/contact-us/` :
          this.url ? this.url :
            `https://se.com/${this.country}/${this.language}/work/support/customer-care/contact-schneider-electric.jsp`;
  
        return supportLink;
    }

    private getLabels(): SupportButtonLabel {
        return SupportButtonLabels[this.language] ?? SupportButtonLabels.en;
    }

    connectedCallback() {
        const closestTabEl = this.el.closest('uiaas-search-tab');
        this.tabName = closestTabEl?.['tabName'] || this.dashboardTabName;

        this.term = this.el?.closest('uiaas-search')?.getAttribute('query') || '';

    }

    private emitSearchStatisticsEvent = (e: AnalyticsGenericEvent) => {
        this.statisticsEventEmitter.emit({
          ...e,
          searchTerm: this.term
        });
    };

    render() {
        const labels = this.getLabels();
        const tab = this.analyticsTabName ?? this.tabName;

        return <Host>
          <a
            class={{
              'link support-button-link': true,
              'support-button-link--full': this.isFullHeight,
              'dashboard-link': this.isDashboardView
            }}
            href={this.getLink()}
            target={this.anchorTarget}
            onMouseDown={(e) => this.emitSearchStatisticsEvent(
              widgetStatistics.sendUserRedirectionStatisticsEvent(tab, e.button == 0 ? 'left' : 'right', this.getLink())
            )}
            onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.emitSearchStatisticsEvent(widgetStatistics.sendUserRedirectionStatisticsEvent(tab, e.key, this.getLink()));
                }
            }}
          >
            {this.isDashboardMobile ? <div class="support-button-dashboard-mobile">
              <div class="support-button-wrapper">
                <se-icon class="icon-large support-icon-dashboard">man_with_headset</se-icon>
                <div>
                  <p class="subtitle1-dashboard">{labels.header}</p>
                  <p class="subtitle2-dashboard">{labels.content}</p>
                </div>
              </div>
              <div class="support-link-dashboard">
                <qds-standalone-link href={this.getLink()}
                >{labels.footer}</qds-standalone-link>
              </div>
            </div> : <div class={{
              'support-button': true,
              'support-link-dashboard-desktop' : this.isDashboardView
            }}>
              <div>
                <se-icon class="icon-large support-icon">man_with_headset</se-icon>
                <p class="subtitle1">{labels.header}</p>
              </div>
              <p class="subtitle2">{labels.content}</p>
              <div class="link-spacer"></div>
              <div class='support-link-container'>
                <qds-standalone-link importance="emphasized" class="support-link" href={this.getLink()}>{labels.footer}</qds-standalone-link>
              </div>

            </div>}
          </a>
        </Host>;
    }
}
